import firebase from "firebase/app"

import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"

const firebaseConfig = {
    apiKey: "AIzaSyBaynyem2F4vjgxBrcaTP2MHfaSGJcOeNo",
    authDomain: "task-tracker-3.firebaseapp.com",
    projectId: "task-tracker-3",
    storageBucket: "task-tracker-3.appspot.com",
    messagingSenderId: "919260481008",
    appId: "1:919260481008:web:d606306943b15ffb42c935"
};

firebase.initializeApp(firebaseConfig)

export const auth = firebase.auth()
export const firestore = firebase.firestore()
export const storage = firebase.storage()

